import { createUseStyles } from 'react-jss'
import { LightTheme } from '../../../theme'

export const useStyle = createUseStyles((theme: LightTheme) => ({
  footer: {
    borderBottom: `1px solid ${theme.colors.shadow}`,
    background: theme.colors.white
  }
}))
